import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, Chip, CircularProgress, Dialog, IconButton, Menu, MenuItem, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css'; 
import CompanyEditor from './CompanyEditor';
import CompanyNumerationDialog from './CompanyNumerationDialog';
import UsersList from 'components/General/Users/UsersList';
import { PiDotsThreeOutlineFill, PiPencilLight, PiXCircleLight } from "react-icons/pi";

export default function CompanyList(props: any) {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {setLoading} = props;

  useEffect(() => {
    setLoading(false);
  }, [])
  
  const [company_list, setUserList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(1);
  const category = queryParams.get('category');
  const [refreshList, setRefreshList] = useState(0);

  const [openEditor, setOpenEditor] = useState(false);
  const [openUserList, setOpenUserList] = useState(false);
  const [openNumerationDialog, setOpenNumerationDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(null);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, companyId: number, company: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedCompanyId(companyId);
    setSelectedCompany(company);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedCompanyId(null);
    setSelectedCompany(null);
  };




  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page])

  /*=========================================================
  LOAD LIST            
  =========================================================*/
  const loadList = () => {
    setLoading(true);
    axios.get(ProjectConfig.api_url+"/companies/list",
    {
      params: {
        page: page,
        role_id: 1,
      }
    })
    .then((response) => {
        console.log("Company List",response.data); 
        setUserList(response.data.list)
        setTotalPages(response.data.total_pages)
        
    })
    .catch((err) => {
      console.log(err.response.data);
    })
    .finally(() => {
      setLoading(false)
    })


    // localStorage.setItem('page', page.toString())
  }

  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (company_id:number) => {
    setActiveItem(company_id)
    setOpenAlert(true)
  }



  const deleteItem = () => {

    const body = {
      company_id: activeItem
    }

    axios.post(ProjectConfig.api_url+"/companies/deleteItem", body)
      .then((response) => {
        console.log(response.data);
        setRefreshList(refreshList + 1)
        if(response.data.status === "success"){
          enqueueSnackbar('Empresa eliminada con éxito', { variant: 'success' });
          loadList();
        }
        
      })
      .catch((err) => {
        console.log(err.message);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }

  /*=========================================================*/

// call global snackbar
  
const [openAlert, setOpenAlert] = useState(false);
const [activeItem, setActiveItem] = useState<any>(null);


const accessAsClient = (company_id: number, company_name: string) => {
  localStorage.setItem('delegated_company_id', company_id.toString())
  localStorage.setItem('delegated_company_name', company_name)
  window.location.href = "/"
}


  
  return (
      <div id='CompaniesList' className='ModuleContainer'>
        <div className="ModuleWrapper"> 
          <div className="boxContainerHeader">
            
            <div className="boxContainerTitle">
              <h2 className="h2_title">Empresas</h2>
              <span className="h2_subtitle">Lista de empresas registradas</span>
            </div>
            
            <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null)
                setOpenEditor(true)
              }}

              startIcon={<AddIcon />}
            >
              Crear empresa
            </Button>

            </div>
            
          </div>

          <div id='CompaniesListIn'>
            
              <Box id='AdminList' className='box100'>
              <TableContainer>
              <Table aria-label="sticky table"> 
                <TableHead>
                  <TableRow>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>NOMBRE / EMAIL</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>NIT</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>Dirección</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {company_list.map((company,i) => (
                      <TableRow 
                        
                        key={i}
                        hover
                        role="checkbox"
                      >
                        <TableCell>
                          <span className='flex_title'>{company.company_name}</span>
                          <span className='flex_subtitle'>{company.email}</span>
                        </TableCell>

                      
                        <TableCell>
                          {company.nit}
                        </TableCell>

                        <TableCell>
                          {company.address}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton onClick={(event) => handleMenuClick(event, company.company_id, company)}>
                            <PiDotsThreeOutlineFill />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            <Pagination count={total_pages} page={page}  onChange={(event, value) => {
              setPage(value)
            }
            } 
            color="primary"
            style={{"marginTop": "20px","alignSelf": "center"}}
            />
            </Box>
  
          </div>
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este usuario?"
            send={deleteItem}
        />

        <CompanyEditor
          company_id={activeItem}
          openEditor={openEditor}
          setOpenEditor={setOpenEditor}
          loadList={loadList}
          setLoading={setLoading}
        />

        <CompanyNumerationDialog
          open={openNumerationDialog}
          setOpen={setOpenNumerationDialog}
          company_id={activeItem}
          current_order_id={String(company_list.find(company => company.company_id === activeItem)?.current_order_id || "")}
          client_code_consecutive_enabled={company_list.find(company => company.company_id === activeItem)?.client_code_consecutive_enabled || false}
          client_code_consecutive_value={String(company_list.find(company => company.company_id === activeItem)?.client_code_consecutive_value || "")}
          loadList={loadList}
          setLoading={setLoading}
        />

        <Dialog 
          open={openUserList}
          onClose={() => setOpenUserList(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="DialogContainer">
            <UsersList
              company_id={activeItem}
              setLoading={setLoading}
              is_popup={true}
            />
          </div>
        </Dialog>

        <Menu
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={() => { setActiveItem(selectedCompanyId); setOpenEditor(true); handleMenuClose(); }}>
            <PiPencilLight style={{ marginRight: 8 }} />
            Editar
          </MenuItem>
          <MenuItem onClick={() => { setActiveItem(selectedCompanyId); setOpenNumerationDialog(true); handleMenuClose(); }}>
            Numeración
          </MenuItem>
          <MenuItem onClick={() => { setActiveItem(selectedCompanyId); setOpenUserList(true); handleMenuClose(); }}>
            Usuarios
          </MenuItem>
          <MenuItem onClick={() => { accessAsClient(selectedCompanyId!, selectedCompany.company_name); handleMenuClose(); }}>
            Acceder como cliente
          </MenuItem>
          <MenuItem onClick={() => { handleDelete(selectedCompanyId!); handleMenuClose(); }} sx={{ color: 'error.main' }}>
            <PiXCircleLight style={{ marginRight: 8 }} />
            Borrar
          </MenuItem>
        </Menu>

    </div>
  );
};